// extracted by mini-css-extract-plugin
module.exports = {"container":"wizardContainer_container__3ICn7","wizardHeading":"wizardContainer_wizardHeading__1gOKl","text":"wizardContainer_text__1ufof"};